// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__nyxwR","mainContent":"Layout_mainContent__6OoEY","expanded":"Layout_expanded__EhLC8","contentWrapper":"Layout_contentWrapper__7V8YQ"};